import React from 'react';

interface NumberFieldProps {
  label: React.ReactNode;
  value: string;
  onChange: (value: string) => void;
  /** Say the unit here rather than in a separate adornment, e.g. "גיל בשנים" */
  placeholder?: string;
  hint?: string;
  min?: number;
  max?: number;
  step?: number;
  decimal?: boolean;
}

const NumberField: React.FC<NumberFieldProps> = ({
  label,
  value,
  onChange,
  placeholder,
  hint,
  min,
  max,
  step,
  decimal = false,
}) => (
  <div className="hema-input-group">
    <label className="hema-label">{label}</label>

    <div className="hema-field">
      <input
        type="text"
        inputMode={decimal ? 'decimal' : 'numeric'}
        value={value}
        onChange={(e) => {
          const raw = e.target.value;
          // Allow empty, digits, decimal point, and minus sign
          if (raw === '' || /^-?\d*\.?\d*$/.test(raw)) {
            onChange(raw);
          }
        }}
        placeholder={placeholder}
        autoComplete="off"
      />
    </div>

    {hint && <p className="hema-hint">{hint}</p>}
  </div>
);

export default NumberField;
